// extracted by mini-css-extract-plugin
module.exports = {"container":"simulationCard_container__YK5vB","title":"simulationCard_title__DQb7v","advantages":"simulationCard_advantages__FrX4Y","benefits":"simulationCard_benefits__pUXkg"};